














































































































































































import { Component, Vue } from "vue-property-decorator";
import TaxEventDTO from "@/dto/tax/TaxEventDTO";
import TaxEventPayload from "@/dto/tax/TaxEventPayload";
import TaxEventCommentPayload from "@/dto/tax/TaxEventCommentPayload";
import TaxEventService from "@/services/TaxEventService";
import PortalTextarea from "@/components/common/PortalTextarea.vue";
import Application from "@/state/Application";
import { processError } from "@/utils/ComponentUtils";
import moment from "moment";
import { CounterpartyType } from "@/constants/CounterpartyType";
import { YEARS } from "@/constants/DateTimeConstants";
import SelectOption from "@/components/common/SelectOption";
import { TaxEventStatus } from "@/constants/TaxEventStatus";
import SublimeEmployeeDTO from "@/dto/sublime/employee/SublimeEmployeeDTO";
import AddLedgerRecordModal from "@/components/admin/tax/AddLedgerRecordModal.vue";
import AddReconciliationRecordModal from "@/components/admin/tax/AddReconciliationRecordModal.vue";

@Component({
  components: {
    AddLedgerRecordModal,
    AddReconciliationRecordModal,
    PortalTextarea
  }
})
export default class TaxEvent extends Vue {
  
  taxEvent: TaxEventDTO | null = null;
  assignee: SublimeEmployeeDTO | null = null;
  commentPayload: TaxEventCommentPayload = new TaxEventCommentPayload();

  get id(): number {
    return Number.parseInt(this.$route.params.id);
  }

  get sortedComments() {
    if (!this.taxEvent || !this.taxEvent.comments) return [];
    return [...this.taxEvent.comments].sort((a, b) => 
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );
  }

  get sortedLedger() {
    if (!this.taxEvent || !this.taxEvent.ledger) return [];
    return [...this.taxEvent.ledger].sort((a, b) => a.order - b.order);
  }

  get latestReconciliation() {
    if (!this.taxEvent || !this.taxEvent.reconciliationRecords || this.taxEvent.reconciliationRecords.length === 0) {
      return null;
    }
    return [...this.taxEvent.reconciliationRecords].sort((a, b) => {
      return new Date(b.verificationDate).getTime() - new Date(a.verificationDate).getTime();
    })[0];
  }

  mounted(): void {
    this.loadEvent();
  }

  loadEvent(): void {
    Application.startLoading();
    TaxEventService.getTaxEvent(this.id).then(
      res => {
        this.taxEvent = res.data;
        
        if (this.taxEvent.assigneeId) {
          this.assignee = {
            id: this.taxEvent.assigneeId,
            firstName: this.taxEvent.assigneeName ? this.taxEvent.assigneeName.split(' ')[0] : '',
            lastName: this.taxEvent.assigneeName && this.taxEvent.assigneeName.split(' ')[1] ? this.taxEvent.assigneeName.split(' ').slice(1).join(' ') : ''
          } as any;
        } else {
          this.assignee = null;
        }

        Application.stopLoading();
      },
      err => processError(err, this)
    );
  }

  public onAssigneeSelected(employee: SublimeEmployeeDTO | null): void {
    // Left for potential future use or just cleanup if truly unneeded. 
    // Since it was in the template and we removed the template part, 
    // we can remove the logic that updates 'form' which is now gone.
    this.assignee = employee;
  }
  
  public getFullPeriod(e: TaxEventDTO): string {
    if(!e.year){
      return '-';
    } else if ((!e.period || e.period === 'FULL_YEAR') && !!e.year){
      return e.year.toString();
    } else {
      return (this as any).$stringUtils.enumToFormattedSentence(e.period) + ' ' + e.year;
    }
  }

  get yearOptions() {
    return YEARS.map(year => SelectOption.builder().title(`${year}`).value(year).build());
  }

  get statusClass(): string {
    if (!this.taxEvent) return '';
    const status = this.taxEvent.status as any;
    switch (status) {
      case 'COMPLETED':
        return 'badge-success';
      case 'OVERDUE':
        return 'badge-danger';
      case 'DUE_SOON':
        return 'badge-warning';
      case 'SCHEDULED':
        return 'badge-info';
      default:
        return 'badge-secondary';
    }
  }

  formatDate(dateStr: string): string {
    if (!dateStr) return "-";
    return moment(dateStr).format('MM-DD-YYYY');
  }

  formatAmount(cents: number): string {
    return '$' + (cents / 100).toFixed(2);
  }

  formatDateTime(dateStr: string): string {
    if (!dateStr) return "-";
    return moment(dateStr).format('MM-DD-YYYY HH:mm');
  }

  addComment(): void {
    if (!this.commentPayload.comment.trim()) return;
    
    Application.startLoading();
    TaxEventService.addComment(this.id, this.commentPayload).then(
      res => {
        Application.stopLoading();
        this.commentPayload = new TaxEventCommentPayload();
        this.loadEvent();
      },
      err => processError(err, this)
    );
  }

  openAddLedgerRecordModal(): void {
    this.$modal.show('add-ledger-record-modal', { taxEventId: this.id });
  }

  openAddReconciliationRecordModal(): void {
    this.$modal.show('add-reconciliation-record-modal', { taxEventId: this.id });
  }
}
